import React, { useState, useEffect } from 'react';

interface ModalProps {
  toggleModal: boolean;
  onClose: (state: boolean) => void;
  children: any;
}

const Modal: React.FC<ModalProps> = ({ toggleModal, onClose, children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(toggleModal);

  useEffect(() => {
    setIsOpen(toggleModal);
  }, [toggleModal]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  return (
    <div
      className={`${
        !isOpen && 'opacity-0 pointer-events-none'
      } fixed h-screen w-screen z-[60] top-0 left-0 bg-system/black/60 cursor-pointer py-0 transition-opacity duration-500`}
      onClick={() => {
        onClose(false);
      }}
    >
      <div className="container mx-auto flex justify-center items-center h-full w-full py-4">
        <div className="relative w-full h-full">
          <div className="absolute -top-12 right-0 cursor-pointer hover:scale-[1.1] transition-all">
            <button
              className="h-[24px] w-[24px] bg-no-repeat bg-system/white hidden sm:block"
              aria-label="close menu"
              onClick={() => onClose(false)}
              style={{
                WebkitMaskImage: "url('/svgs/close.svg')",
                maskImage: "url('/svgs/close.svg')",
              }}
            />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
